module.exports = __webpack_public_path__ + "static/ACvoice-fe832dd21cc331af053a556407edb430.mp4";